import Quill, { Delta } from 'quill/core';
import type { EmbedBlot } from '../types';

const replaceBlotWith = (
  quill: Quill,
  blot: EmbedBlot,
  insertion: string | Record<string, unknown>,
  attributes?: Record<string, unknown>,
) => {
  const index = blot.offset(quill.scroll);
  quill.history.cutoff();

  quill.deleteText(index, 1, Quill.sources.USER);

  // updateContents() may create "\n" implicitly, so
  // we rely on the actual change to get the insertion index.
  const change = quill.updateContents(
    new Delta().retain(index).insert(insertion, attributes),
    Quill.sources.USER,
  );
  const length = typeof insertion === 'string' ? insertion.length : 1;

  quill.history.cutoff();
  // @ts-expect-error
  quill.focusWithoutScrolling();
  quill.setSelection(change.length() - length, length, Quill.sources.USER);
};

export default replaceBlotWith;
